import { useState as b, useRef as d, useCallback as h } from "react";
const g = (s) => {
  const [l, a] = b({ width: void 0, height: void 0 }), o = d(null), c = h(
    (t) => {
      var e;
      try {
        const n = t[t.length - 1], u = s === "content-box" ? "contentBoxSize" : "borderBoxSize", i = (e = n == null ? void 0 : n[u]) == null ? void 0 : e[0];
        i && requestAnimationFrame(() => {
          a((r) => r.width !== i.inlineSize || r.height !== i.blockSize ? { width: i.inlineSize, height: i.blockSize } : r);
        });
      } catch (n) {
        console.error("Error handling resize:", n);
      }
    },
    [s]
  ), z = h(
    (t) => {
      o.current || (o.current = new ResizeObserver(c));
      const e = o.current;
      t && e && (e.disconnect(), e.observe(t));
    },
    [c]
  );
  return [l, z];
};
export {
  g as u
};
